module.exports = __webpack_public_path__ + "930ee4024dbfa27d858e11bc46ce22c5.svg";